import styled, { css } from 'styled-components'

import theme from 'theme_'
import { Dropdown } from 'components/Input'
import { Font14 } from 'components/Typography'
import { WhiteBlock } from 'components/Layout'

export const ProcessLogLevelDropdown = styled(Dropdown)`
  width: 120px;

  @media ${theme.devices.desktop} {
    width: 150px;
  }

  .select__control--is-disabled {
    pointer-events: auto;
    cursor: not-allowed;

    .select__dropdown-indicator,
    .select__single-value {
      color: ${theme.colors.darkeyGrey};
    }
  }

  .select__dropdown-indicator {
    color: ${theme.colors.otterWarmBlack};
  }

  .select__menu {
    position: absolute;

    background: ${theme.colors.white};
    box-shadow: 0 4px 40px ${theme.colors.commonShadow};
    border-radius: 8px;
  }
  .select__value-container {
    padding: 0;
  }
  .select__control--is-focused {
    border: none;
    box-shadow: none;
  }

  .select__control {
    border: none;
    background: none;

    &:hover {
      border: none;
    }
  }
`

export const ProcessLogLevelWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`
export const ProcessCard = styled(WhiteBlock)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.s};
  padding: ${theme.spacing.base};
`

export const ProcessCardRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const ProcessCardTitle = styled.span`
  font-weight: bold;
  ${Font14}
`

export const ProcessLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-weight: normal;
  ${Font14};
  color: ${theme.colors.moreGrey};
`

export const MobileProcessSpinnerWrapper = styled.div`
  width: 32px;
  height: 32px;
`

export const MobileProcessCell = styled.label``

export const CellHomeProcessInfoStyles = css`
  padding: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
`
export const CellHomeProcessNameStyles = css`
  padding: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
`

export const CellHomeProcessInfoStatusStyles = css`
  padding: 8px;
`
export const CellHomeProcessProcessorInfoStatusStyles = css`
  padding: 8px 0px;
`
